// extracted by mini-css-extract-plugin
module.exports = {"container":"doc-feedback-prompt_container__E7_8O"};